import { selectIsUserStandard } from '../../../../redux/auth/user/selectors';
import { selectPaymentSuccess } from '../../../../redux/router/selectors';
import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

export const selectIsVisible = createDeepEqualSelector(
  [selectIsUserStandard, selectPaymentSuccess],
  (isUserStandard, paymentSuccess) => !isUserStandard && paymentSuccess,
);
